import React from "react";

type Props = {
  value: string;
  style?: React.CSSProperties;
  className?: string;
  numberOfLines?: number; // Add prop for line limit
};

export const TCText: React.FC<Props> = ({
  value,
  style,
  className,
  numberOfLines,
}) => {
  const lineClampStyle: React.CSSProperties = numberOfLines
    ? {
        display: "-webkit-box",
        WebkitLineClamp: numberOfLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }
    : {};

  return (
    <div
      className={className}
      style={{
        ...style,
        ...lineClampStyle,
      }}>
      {value}
    </div>
  );
};
